import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ArrowForwardIos } from '@mui/icons-material';
function DCConfirmationBreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid p-0 breadcrumb">
      {vPathName === '/DCConfirmation' ? (
        <div>
          <span className="breadcrumb-arrow-inactive">
            DC Confirmation{' '}
          </span>
        </div>
      ) : vPathName === '/DCConfirmationDetail' ? (
        <div className="d-flex">
          <Link
            to="/DCConfirmation"
            state={location}
            className={'breadcrumb-arrow-active mr-2'}>
            DC Confirmation
          </Link>
          {/* <ArrowForwardIos color="info" style={{ marginRight: '1px' }} /> */}
          <div>
            <span className="breadcrumb-arrow-inactive"> DC Confirmation Detail{' '}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
export default DCConfirmationBreadCrumbs;
